<div class="mt-4 col-md-12">
  <button class="btn btn-primary w-100" (click)="onSubmit()">
    <span *ngIf="!isExcelReportLoaded" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    Download Report
  </button>
</div>